import ApiService from '../../../services/ApiService';

interface IApiService {
  delete(uri: string, config?: object): any;
  get(uri: string, config?: object): any;
  post(uri: string, postBody: object, config?: object): any;
  put(uri: string, postBody?: object, config?: object): any;
}

export interface IApiResponse {
  data: any;
  request: XMLHttpRequest;
  status: number;
  satusText: string;
}

export const Api: IApiService = ApiService as any;
